import styled from "styled-components";
import { AvailableKey, BankHolidayKey, CollectionKey, CollectionReturnKey, ReturnCollectionKey, ReturnKey, SelectedKey, UnavailableKey } from "./KeyColours";

export type ContainerProps = {
    $selectable: boolean;
    $selected: boolean;
    $available: boolean;
    $visible: boolean;
    $bankHoliday: boolean;
    $isCollection: boolean;
    $isReturn: boolean;
    $bookedCollection: boolean;
    $bookedReturn: boolean;
}
export const DateBlock = styled.td<ContainerProps>`
    font-family: Poppins-Regular;
    text-align: center;
    ${props => !props.$selectable && props.$available && "opacity: 0.5"};
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    ${props => props.$available && props.$selectable && "cursor: pointer"};
    width: 7vw;
    height: 3.4vw;
    word-spacing: 7vw;
    @media (min-width: 640px) {
        word-spacing: unset;
    }
    ${props => {
        if (props.$visible) {
            if (props.$selected) {
                if (props.$isCollection) {
                    if (props.$bookedCollection) {
                        return ReturnCollectionKey;
                    }
                    else {
                        return props.$bookedReturn ? CollectionReturnKey : CollectionKey(true);
                    }
                }
                else if (props.$isReturn) {
                    if (props.$bookedReturn) {
                        return CollectionReturnKey;
                    }
                    else {
                        return props.$bookedCollection ? ReturnCollectionKey : ReturnKey(true);
                    }
                }
                else {
                    return SelectedKey;
                }
            }
            else if (props.$bookedCollection) {
                return CollectionKey(false);
            }
            else if (props.$bookedReturn) {
                return ReturnKey(false);
            }
            else if (props.$bankHoliday) {
                return BankHolidayKey;
            }
            else {
                if (props.$available) {
                    return AvailableKey(props.$selectable);
                }
                else {
                    return UnavailableKey;
                }
            }
        }
    }}
`;
